export default __webpack_public_path__ + "static/media/279062323_3162152564060462_1745201231914805408_n.d32cd692.jpg";